import { ThunkResult } from "..";
import { apiGet } from "../../utils/api";
import * as actions from "./actions";
import { IURLResponse } from "./types";
interface IURLPendingResponse {
  detail: string;
}
type IFetchURLResponse = IURLResponse | IURLPendingResponse;

const isPendingResponse = (
  response: IFetchURLResponse,
): response is IURLPendingResponse => {
  return "detail" in response;
};

const isEmptyResponse = (response: IURLResponse) => {
  return Object.values(response).every((value) => value === "");
};

export const fetchURL =
  (url: string): ThunkResult<Promise<void>> =>
  async (dispatch) => {
    try {
      const response = await apiGet<IFetchURLResponse>(
        `get-url/?url=${url}`,
        dispatch,
        actions.fetchURL,
        { url },
      );

      if (isPendingResponse(response) || isEmptyResponse(response)) {
        setTimeout(() => dispatch(fetchURL(url)), 3000);
      }
    } catch (e) {
      return;
    }
  };
